import React from 'react'
import { RichText, Region, type ComponentProps, type ExtendedRichTextData, type LayoutData } from '@enonic/react-components'
import ReferencePrototype from '/react4xp/components/prototype/Reference'

type Tag = {
	value: string
	label: string
}

type ReferenceStrings = {
	customerLabel: string
	deliveryLabel: string
}

type ReferenceLayoutData = {
	title?: string
	clientName?: string
	leveranse?: string
	tags?: Tag[]
	image?: { src: string; alt?: string }
	intro?: string
	review?: ExtendedRichTextData
	strings?: ReferenceStrings
	error?: string
}

export const Reference = ({ component, meta, data, common }: ComponentProps<LayoutData>) => {
	const { title, clientName, leveranse, tags = [], image, intro, review, strings } = (data || {}) as ReferenceLayoutData

	return (
		<>
			<ReferencePrototype
				title={title || ''}
				customerLabel={strings?.customerLabel}
				customer={clientName}
				deliveryLabel={strings?.deliveryLabel}
				delivery={leveranse}
				tags={tags.map(({ label }) => ({ label }))}
				image={image}
				ingress={intro}
				content={
					review && [
						{
							text: <RichText tag="div" data={review} component={component} meta={meta} common={common} />,
						},
					]
				}
			/>
			<Region name="main" data={component?.regions?.main?.components || []} meta={meta} />
		</>
	)
}
